export function mascaraCuit(cuit) {
    const apenasNumeros = cuit.replace(/\D/g, '');

    const formato = apenasNumeros.replace(
        /^(\d{2})(\d{8})(\d{1})$/,
        '$1-$2-$3'
    );

    return formato;
}
